import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://asafespacellc.com";

// Per-route titles + descriptions, all keyword-rich for the terms Dora wants found.
const ROUTES = {
    "/": {
        title: "NeuroPlay Counseling, LLC — Play Therapy, Therapy & Therapist Training | Longwood, FL",
        description:
            "A warm space for healing and mental health. Play therapy, EMDR & trauma-informed therapy and neuropsychology-based therapist training with Dora Henderson & Ryan Uner in Longwood, Florida. NeuroPlay Counseling, LLC.",
    },
    "/about": {
        title: "Our Story — Meet Our Therapists: Dora, Ryan, Shannon, Tessa & Jessica | NeuroPlay Counseling",
        description:
            "Meet Dora Henderson (LMHC-QS, RPT-S), Ryan Uner (LMHC), Shannon Stieg (LMHC), Tessa Voorhees (RCSWI) and Jessica Castro (RMHCI) — play therapy, EMDR, LGBTQIA2S+ and neurodivergent-affirming care in Longwood, FL.",
    },
    "/services": {
        title: "Services — Play Therapy, EMDR & Trauma Therapy | NeuroPlay Counseling",
        description:
            "Therapy services for children, teens and adults: play therapy, EMDR, trauma-informed care, crisis intervention and neuropsychology-informed mental health support in Longwood, FL. NeuroPlay Counseling, LLC.",
    },
    "/app": {
        title: "Get the App & Admin Sign-in | NeuroPlay Counseling",
        description:
            "Install the NeuroPlay Counseling app on your phone or computer, and sign in to the team admin control panel.",
    },
    "/trainings": {
        title: "Therapist Training — Neuropsychology & Play Therapy CE | NeuroPlay Counseling",
        description:
            "Therapist training and continuing education with Dora Henderson: neuropsychology, polyvagal theory, EMDR-informed play therapy, supervision and more.",
    },
    "/books": {
        title: "Therapist Books — Neuro & the 'Ception Force Friends | NeuroPlay Counseling",
        description:
            "Children's therapy books by Dora Henderson and Ryan Uner — neuroscience, play therapy and healing made friendly for little readers.",
    },
    "/rates": {
        title: "Insurance & Rates | NeuroPlay Counseling",
        description:
            "Insurance and self-pay rates for therapy in Longwood, Florida. Most plans billed through Headway for accessible mental health care.",
    },
    "/faqs": {
        title: "FAQs — What Therapy Feels Like | NeuroPlay Counseling",
        description:
            "Answers about play therapy, telehealth, privacy and what to expect from a safe, healing therapy experience.",
    },
    "/visit": {
        title: "Location & Hours — Longwood, Florida | NeuroPlay Counseling",
        description:
            "Visit NeuroPlay Counseling, LLC at 1250 S US Hwy 17-92, Suite 150, Longwood, FL 32750 — a warm space for therapy and healing.",
    },
    "/contact": {
        title: "Contact Us | NeuroPlay Counseling — Longwood, FL",
        description:
            "Reach NeuroPlay Counseling in Longwood, Florida for play therapy, therapist training and mental health support. We reply within a day.",
    },
    "/blog": {
        title: "Blog — Neuropsychology & Play Therapy Insights | NeuroPlay Counseling",
        description:
            "Articles on neuropsychology, play therapy, healing and mental health from Dora Henderson and the NeuroPlay Counseling team.",
    },
    "/events": {
        title: "Events & Trainings | NeuroPlay Counseling",
        description:
            "Upcoming therapist trainings, workshops and events on play therapy, neuropsychology and healing.",
    },
};

export default function RouteSeo() {
    const { pathname } = useLocation();
    const meta = ROUTES[pathname] || (pathname.startsWith("/blog/") ? ROUTES["/blog"] : ROUTES["/"]);
    const url = `${SITE}${pathname === "/" ? "" : pathname}`;
    return (
        <Helmet>
            <title>{meta.title}</title>
            <meta name="description" content={meta.description} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={meta.title} />
            <meta property="og:description" content={meta.description} />
            <meta property="og:url" content={url} />
            <meta name="twitter:title" content={meta.title} />
            <meta name="twitter:description" content={meta.description} />
        </Helmet>
    );
}
